import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { loadStripe } from '@stripe/stripe-js';
import {
  CardElement,
  Elements,
  useStripe,
  useElements
} from '@stripe/react-stripe-js';
import { STRIPE_PUBLISHABLE_KEY } from '../Common/constant';
import LocalStrings from '../../languages';

const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);

const CheckoutForm = props => {
  const [isClicked, setIsClicked] = useState(false);

  const stripe = useStripe();
  const elements = useElements();

  const handleSubmit = async event => {
    if (!isClicked) {
      setIsClicked(true);
      event.preventDefault();
      const card = elements.getElement(CardElement);
      const result = await stripe.createToken(card);
      // const {error, paymentMethod} = await stripe.createPaymentMethod({
      //     type: 'card',
      //     card: elements.getElement(CardElement),
      // });

      // console.log('result : - ', result);
      if (result.error) {
        // console.log('error :- ', result.error);
        props.onTokenReceived(null, error);
      } else {
        props.onTokenReceived(result.token, null);
      }
    }
  };

  var ladingCourseButton = props.loadPaidItem ? 'fa fa-refresh fa-spin' : '';
  var saveDisabled = props.loadPaidItem;

  return (
    <>
      <div className="form-group">
        <div className="form-control stripe-form">
          <CardElement />
        </div>
      </div>

      <button
        type="submit"
        className="custom-button-primary-lg w-100 mt-2"
        disabled={saveDisabled}
        onSubmit={handleSubmit}
      >
        <i className={ladingCourseButton}></i>
        &ensp;
        {LocalStrings.button_pay}
      </button>
    </>
  );
};

const Stripe = props => (
  <Elements stripe={stripePromise}>
    <CheckoutForm {...props} />
  </Elements>
);

const mapStateToProps = state => ({
  session: state.session
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Stripe);
